import { AxiosRequestConfig, AxiosResponse } from 'axios';

// #region enum
export enum Status {
  IDLE = 'idle',
  LOADING = 'loading',
  ERROR = 'error',
  SUCCESS = 'success',
}
// #endregion

// #region data structure types
export interface Ordered {
  DisplayOrder: number;
}

interface Idle {
  status: Status.IDLE;
}

interface Loading {
  status: Status.LOADING;
}

interface Failed {
  status: Status.ERROR;
  error?: string | Error | AxiosError;
}

interface Success<T> {
  status: Status.SUCCESS;
  data: T;
}

export type Async<T> = Loading | Failed | Success<T>;

export type AsyncIdle<T> = Idle | Async<T>;

export interface AsyncMap<T> {
  [key: string]: Async<T> | undefined;
}

export interface DataDictionary<T> {
  [key: string]: T;
}
// #endregion

// #region API response types
export interface Result<T> {
  Code: number;
  Data: T;
  DeveloperMessage: string;
  StackTrace: string;
  Success: boolean;
  UserMessage: string;
}

export interface AxiosError extends Error {
  config: AxiosRequestConfig;
  code?: number;
  request?: any;
  response?: AxiosResponse<Result<any>>;
}
// #endregion
